(function () {
  var VERSION = 'mida-volume-home-basis-kissenbezug-v2';
  var PRODUCT_HANDLE = 'home-kissenbezug-baumwolle';
  var PRODUCT_ID = '6611471794329';
  var DEFAULT_QTY = 1;
  var FALLBACK_IMAGE = 'https://www.mysheepi.com/cdn/shop/files/mySheepi-HOME-Kissenbezug-Standard-beige.png?v=1776948699&width=180';

  var TIERS = [
    { qty: 1, title: '1 Kissenbezug', subtitle: 'Farbe oben auswählen', discount: 0, badge: '', tag: 'Kein Rabatt' },
    { qty: 2, title: '2er-Pack', subtitle: 'Zweite Farbe auswählen', discount: 0.15, badge: 'BELIEBT', tag: 'Spare 15%' },
    { qty: 4, title: '4er-Pack', subtitle: 'Farben auswählen', discount: 0.3, badge: 'BESTER DEAL', tag: 'Spare 30%' }
  ];

  var SWATCHES = {
    beige: '#d8c7b2',
    hellgrau: '#b9b9b4',
    dunkelblau: '#1c2f52',
    weiss: '#f7f4ed'
  };

  var COLOR_IMAGES = {
    beige: 'https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mySheepi-HOME-Kissenbezug-Standard-beige.png?v=1776948699&width=180',
    hellgrau: 'https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mySheepi-HOME-Kissenbezug-Standard-hellgrau.png?v=1776948689&width=180',
    dunkelblau: 'https://cdn.shopify.com/s/files/1/0348/6482/4451/files/Blauer_Bezug_Frontal_s_1e65a66d-50a8-4ce3-9de6-dd3daad3f0b2.jpg?v=1766997554&width=180',
    weiss: 'https://cdn.shopify.com/s/files/1/0348/6482/4451/files/mysheepi-kissenbezug-weiss-front.jpg?v=1766997554&width=180'
  };

  var state = {
    selectedQty: DEFAULT_QTY,
    extraColors: [],
    extraTouched: [],
    variants: [],
    scheduled: false,
    adding: false
  };

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function selectedSwatchText(fieldset) {
    var span = fieldset && fieldset.querySelector('[data-selected-swatch-value]');
    return span ? span.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/weiß/g, 'weiss')
      .replace(/ö/g, 'oe')
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[()]/g, '')
      .replace(/\s+/g, '-')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getTier(qty) {
    qty = Number(qty);
    return TIERS.filter(function (tier) { return tier.qty === qty; })[0] || TIERS[0];
  }

  function applySingleDiscountCohort() {
    var assignment = window.mysheepiAbAssignments && window.mysheepiAbAssignments.kissenbezugSingleDiscount;
    var discountApplied = !!(assignment && assignment.discountApplied);

    TIERS[0].discount = discountApplied ? 0.1 : 0;
    TIERS[0].tag = discountApplied ? 'Spare 10%' : 'Kein Rabatt';
  }

  function getVariantSelects() {
    return document.querySelector('variant-selects[data-product-handle="' + PRODUCT_HANDLE + '"]') ||
      document.querySelector('variant-selects[data-url*="' + PRODUCT_HANDLE + '"]');
  }

  function getMainProductFormEl() {
    return document.querySelector('product-form[data-product-form][data-product-title="HOME Basis Kissenbezug"]') ||
      document.querySelector('product-form[data-product-title="HOME Basis Kissenbezug"]');
  }

  function getMainForm() {
    var productForm = getMainProductFormEl();
    var scopedForm = productForm && productForm.querySelector('form[action*="/cart/add"]');

    return scopedForm ||
      document.querySelector('form.product-form-submit[data-product-id="' + PRODUCT_ID + '"]') ||
      document.querySelector('form[action*="/cart/add"][data-product-id="' + PRODUCT_ID + '"]');
  }

  function getCartForms() {
    var forms = [];
    var mainForm = getMainForm();

    if (mainForm) forms.push(mainForm);

    toArray(document.querySelectorAll('sticky-atc form[action*="/cart/add"], form.sticky-atc-form[action*="/cart/add"]')).forEach(function (form) {
      if (forms.indexOf(form) === -1) forms.push(form);
    });

    return forms;
  }

  function isTargetPage() {
    return !!getVariantSelects() || window.location.pathname.indexOf('/products/' + PRODUCT_HANDLE) !== -1;
  }

  function getFieldsets() {
    var variantSelects = getVariantSelects();
    return variantSelects ? toArray(variantSelects.querySelectorAll('fieldset.product-form__input')) : [];
  }

  function getFieldsetName(fieldset) {
    var input = fieldset && fieldset.querySelector('input[type="radio"]');
    var legend = fieldset && fieldset.querySelector('legend');
    return (input && input.name) || (legend ? legend.textContent.replace(/\s+/g, ' ').replace(/:$/, '').trim() : '');
  }

  function getOptionKind(name) {
    var text = normalize(name);

    if (text.indexOf('farbe') !== -1 || text.indexOf('color') !== -1 || text.indexOf('colour') !== -1) return 'color';
    if (text.indexOf('groesse') !== -1 || text.indexOf('size') !== -1) return 'size';

    return 'other';
  }

  function getOptionMeta() {
    var meta = { colorFieldset: null, sizeFieldset: null, colorIndex: 0, sizeIndex: 1 };

    getFieldsets().forEach(function (fieldset, index) {
      var kind = getOptionKind(getFieldsetName(fieldset));

      if (kind === 'color' && !meta.colorFieldset) {
        meta.colorFieldset = fieldset;
        meta.colorIndex = index;
      }

      if (kind === 'size' && !meta.sizeFieldset) {
        meta.sizeFieldset = fieldset;
        meta.sizeIndex = index;
      }
    });

    return meta;
  }

  function loadVariants() {
    var variantSelects = getVariantSelects();
    var json = variantSelects && variantSelects.querySelector('script[type="application/json"]');

    if (!json) return state.variants;

    try {
      state.variants = JSON.parse(json.textContent) || [];
    } catch (e) {
      state.variants = [];
    }

    return state.variants;
  }

  function getVariantOptions(variant) {
    return variant ? (variant.options || [variant.option1, variant.option2, variant.option3]) : [];
  }

  function getCurrentVariantFromNative() {
    var variants = state.variants.length ? state.variants : loadVariants();
    var variantSelects = getVariantSelects();
    var form = getMainForm();
    var idInput = form && form.querySelector('input.product-variant-id[name="id"], input[name="id"], select[name="id"]');
    var selectedId = idInput && idInput.value;
    var selectedOptions;
    var variant;

    if (variantSelects && variantSelects.currentVariant) return variantSelects.currentVariant;

    if (selectedId) {
      variant = variants.filter(function (item) { return String(item.id) === String(selectedId); })[0];
      if (variant) return variant;
    }

    selectedOptions = getFieldsets().map(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      return selectedSwatchText(fieldset) || (checked ? checked.value : null);
    });

    if (selectedOptions.length && selectedOptions.every(Boolean)) {
      variant = variants.filter(function (item) {
        var options = getVariantOptions(item);
        return selectedOptions.every(function (value, index) { return options[index] === value; });
      })[0];

      if (variant) return variant;
    }

    return variants.filter(function (item) { return item.available; })[0] || variants[0] || null;
  }

  function getSelectedSize() {
    var meta = getOptionMeta();
    var current = getCurrentVariantFromNative();
    var options = getVariantOptions(current);
    var checked = meta.sizeFieldset && meta.sizeFieldset.querySelector('input[type="radio"]:checked');

    return options[meta.sizeIndex] || (checked && checked.value) || selectedSwatchText(meta.sizeFieldset) || '';
  }

  function getNativeSelectedColor() {
    var meta = getOptionMeta();
    var current = getCurrentVariantFromNative();
    var options = getVariantOptions(current);
    var checked = meta.colorFieldset && meta.colorFieldset.querySelector('input[type="radio"]:checked');

    return options[meta.colorIndex] || (checked && checked.value) || selectedSwatchText(meta.colorFieldset) || '';
  }

  function getVisibleColorValues() {
    var meta = getOptionMeta();
    var values = [];

    if (meta.colorFieldset) {
      toArray(meta.colorFieldset.querySelectorAll('input[type="radio"]')).forEach(function (input) {
        if (values.indexOf(input.value) === -1) values.push(input.value);
      });
    }

    loadVariants().forEach(function (variant) {
      var color = getVariantOptions(variant)[meta.colorIndex];
      if (color && values.indexOf(color) === -1) values.push(color);
    });

    return values;
  }

  function findVariant(color, size) {
    var meta = getOptionMeta();
    var variants = state.variants.length ? state.variants : loadVariants();

    return variants.filter(function (variant) {
      var options = getVariantOptions(variant);
      return (!color || options[meta.colorIndex] === color) && (!size || options[meta.sizeIndex] === size);
    })[0] || null;
  }

  function getColorOptions() {
    var selectedSize = getSelectedSize();

    return getVisibleColorValues().map(function (color) {
      var variant = findVariant(color, selectedSize);

      return {
        label: color,
        value: color,
        available: !!(variant && variant.available !== false),
        variant: variant
      };
    });
  }

  function getFallbackColor() {
    var nativeColor = getNativeSelectedColor();
    var options = getColorOptions();
    var matchingNative = options.filter(function (option) {
      return option.value === nativeColor && option.available;
    })[0];
    var firstAvailable = options.filter(function (option) { return option.available; })[0];

    return (matchingNative && matchingNative.value) || (firstAvailable && firstAvailable.value) || (options[0] && options[0].value) || nativeColor || '';
  }

  function normalizeExtraColors() {
    var count = Math.max(0, getTier(state.selectedQty).qty - 1);
    var nativeColor = getNativeSelectedColor();
    var fallback = getFallbackColor();
    var options = getColorOptions();

    state.extraColors = state.extraColors.slice(0, count);
    state.extraTouched = state.extraTouched.slice(0, count);

    while (state.extraColors.length < count) {
      state.extraColors.push(nativeColor || fallback);
      state.extraTouched.push(false);
    }

    state.extraColors = state.extraColors.map(function (color, index) {
      var preferred = state.extraTouched[index] ? color : (nativeColor || color);
      var matching = options.filter(function (option) {
        return option.value === preferred && option.available;
      })[0];

      if (matching) return matching.value;

      state.extraTouched[index] = false;
      return fallback;
    });
  }

  function normalizeImageSrc(src) {
    if (!src) return FALLBACK_IMAGE;
    if (src.indexOf('//') === 0) return 'https:' + src;
    if (src.charAt(0) === '/') return window.location.origin + src;
    return src;
  }

  function getColorImage(color) {
    return COLOR_IMAGES[normalize(color)] || '';
  }

  function getVariantImage(variant) {
    var variantSelects = getVariantSelects();
    var featured = variant && variant.featured_image;
    var media = variant && variant.featured_media;
    var color = getVariantOptions(variant)[getOptionMeta().colorIndex];
    var src = '';

    if (featured) src = featured.src || (featured.preview_image && featured.preview_image.src) || '';
    if (!src && media) src = (media.preview_image && media.preview_image.src) || media.src || '';
    if (!src && color) src = getColorImage(color);
    if (!src && variantSelects) src = variantSelects.dataset.productFeaturedImage || '';

    src = normalizeImageSrc(src || FALLBACK_IMAGE);

    if (src.indexOf('width=') !== -1) {
      return src.replace(/([?&])width=\d+/g, '$1width=180');
    }

    return src;
  }

  function getSwatchColor(color) {
    return SWATCHES[normalize(color)] || '#d8d1c4';
  }

  function formatMoney(cents) {
    var euros = Math.floor(Number(cents) / 100);

    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(euros);
    } catch (e) {
      return euros + ' €';
    }
  }

  function getBaseUnitPrice() {
    var nativeVariant = findVariant(getNativeSelectedColor(), getSelectedSize()) || getCurrentVariantFromNative();
    return nativeVariant ? Number(nativeVariant.price) || 0 : 0;
  }

  function getSelectionColors() {
    normalizeExtraColors();
    return [getNativeSelectedColor()].concat(state.extraColors).slice(0, getTier(state.selectedQty).qty);
  }

  function closeAllDropdowns(except) {
    toArray(document.querySelectorAll('.mida-volume-dd.is-open')).forEach(function (dropdown) {
      if (dropdown === except) return;
      dropdown.classList.remove('is-open');
      var btn = dropdown.querySelector('[data-mida-dd-button]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function makeMediaHtml(qty) {
    var count = Math.min(Number(qty) || 1, 4);
    var html = '';

    for (var i = 0; i < count; i += 1) {
      html += '<img src="' + FALLBACK_IMAGE + '" alt="" loading="lazy">';
    }

    return html;
  }

  function makeTierHtml(tier) {
    var selected = tier.qty === state.selectedQty;
    var klass = 'mida-volume-tier' + (selected ? ' is-selected' : '') + (tier.badge ? ' has-badge' : '');
    var badge = tier.badge ? '<span class="mida-volume-tier__badge">' + escapeHtml(tier.badge) + '</span>' : '';

    return '' +
      '<label class="' + klass + '" data-mida-volume-tier data-qty="' + tier.qty + '">' +
        badge +
        '<input class="mida-volume-tier__input" type="radio" name="mida-volume-tier" value="' + tier.qty + '"' + (selected ? ' checked' : '') + '>' +
        '<span class="mida-volume-tier__radio" aria-hidden="true"></span>' +
        '<span class="mida-volume-tier__media" aria-hidden="true">' + makeMediaHtml(tier.qty) + '</span>' +
        '<span class="mida-volume-tier__copy">' +
          '<span class="mida-volume-tier__title">' + escapeHtml(tier.title) + '</span>' +
          '<span class="mida-volume-tier__subtitle">' + escapeHtml(tier.subtitle) + '</span>' +
          '<span class="mida-volume-tier__tag">' + escapeHtml(tier.tag) + '</span>' +
        '</span>' +
        '<span class="mida-volume-tier__prices">' +
          '<strong data-mida-tier-final></strong>' +
          '<s data-mida-tier-compare hidden></s>' +
          '<span data-mida-tier-unit></span>' +
        '</span>' +
      '</label>';
  }

  function buildBlock() {
    var block = document.createElement('section');

    block.className = 'mida-volume';
    block.dataset.midaVolumeProduct = PRODUCT_HANDLE;
    block.dataset.midaVersion = VERSION;
    block.setAttribute('aria-label', 'Mengenrabatt auswählen');

    block.innerHTML =
      '<div class="mida-volume__header">' +
        '<div>' +
          '<span class="mida-volume__eyebrow">Mengenrabatt</span>' +
          '<h3>Wähle Dein Angebot:</h3>' +
        '</div>' +
        '<span class="mida-volume__top-badge">Bis zu 30% sparen</span>' +
      '</div>' +
      '<div class="mida-volume__tiers">' + TIERS.map(makeTierHtml).join('') + '</div>' +
      '<div class="mida-volume-config">' +
        '<div class="mida-volume-config__head">' +
          '<span>Zusätzliche Farben wählen</span>' +
          '<strong data-mida-volume-size></strong>' +
        '</div>' +
        '<div class="mida-volume-config__first" data-mida-volume-first></div>' +
        '<div class="mida-volume-lines" data-mida-volume-lines></div>' +
      '</div>' +
      '<div class="mida-volume__summary">' +
        '<span class="mida-volume__summary-label">Gesamtpreis</span>' +
        '<span class="mida-volume__summary-prices">' +
          '<s data-mida-volume-compare hidden></s>' +
          '<strong data-mida-volume-total></strong>' +
        '</span>' +
        '<span class="mida-volume__summary-save" data-mida-volume-save></span>' +
      '</div>' +
      '<p class="mida-volume__error" data-mida-volume-error hidden></p>';

    block.addEventListener('click', function (event) {
      var tierCard = event.target.closest && event.target.closest('[data-mida-volume-tier]');
      if (tierCard) {
        selectTier(Number(tierCard.dataset.qty));
      }
    });

    return block;
  }

  function makeDropdownOptionsHtml(selectedColor, index) {
    return getColorOptions().map(function (option) {
      var selected = option.value === selectedColor;
      var klass = 'mida-volume-dd__option' + (selected ? ' is-selected' : '') + (!option.available ? ' is-sold-out' : '');

      return '' +
        '<button type="button" class="' + klass + '" role="option" data-mida-extra-color-option data-index="' + index + '" data-value="' + escapeHtml(option.value) + '" aria-selected="' + (selected ? 'true' : 'false') + '" aria-disabled="' + (!option.available ? 'true' : 'false') + '">' +
          '<span class="mida-volume-dd__option-swatch" style="background:' + getSwatchColor(option.value) + '"></span>' +
          '<span class="mida-volume-dd__option-label">' + escapeHtml(option.label) + '</span>' +
          '<span class="mida-volume-dd__option-status">' + (option.available ? '' : 'Ausverkauft') + '</span>' +
        '</button>';
    }).join('');
  }

  function makeColorDropdownHtml(selectedColor, index) {
    return '' +
      '<div class="mida-volume-dd" data-mida-volume-dd data-index="' + index + '">' +
        '<button type="button" class="mida-volume-dd__button" data-mida-dd-button aria-haspopup="listbox" aria-expanded="false">' +
          '<span class="mida-volume-dd__selected-swatch" style="background:' + getSwatchColor(selectedColor) + '"></span>' +
          '<span class="mida-volume-dd__selected-label">' + escapeHtml(selectedColor || 'Farbe wählen') + '</span>' +
        '</button>' +
        '<div class="mida-volume-dd__menu" role="listbox">' + makeDropdownOptionsHtml(selectedColor, index) + '</div>' +
      '</div>';
  }

  function bindDropdownHandlers(lines) {
    toArray(lines.querySelectorAll('[data-mida-dd-button]')).forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
        var dropdown = btn.closest('.mida-volume-dd');
        if (!dropdown) return;
        var isOpen = dropdown.classList.contains('is-open');
        closeAllDropdowns(null);
        if (!isOpen) {
          dropdown.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    toArray(lines.querySelectorAll('[data-mida-extra-color-option]')).forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (btn.getAttribute('aria-disabled') === 'true') return;
        state.extraColors[Number(btn.dataset.index)] = btn.dataset.value;
        state.extraTouched[Number(btn.dataset.index)] = true;
        closeAllDropdowns(null);
        updateUI();
      });
    });
  }

  function renderExtraLines(block) {
    var lines = block.querySelector('[data-mida-volume-lines]');
    var html = '';

    normalizeExtraColors();

    state.extraColors.forEach(function (selectedColor, index) {
      html += '' +
        '<div class="mida-volume-line" data-mida-extra-line data-index="' + index + '">' +
          '<span class="mida-volume-line__number">' + (index + 2) + '</span>' +
          '<img class="mida-volume-line__img" src="' + FALLBACK_IMAGE + '" alt="" loading="lazy">' +
          '<div class="mida-volume-line__field">' +
            '<span>Kissenbezug ' + (index + 2) + '</span>' +
            makeColorDropdownHtml(selectedColor, index) +
          '</div>' +
          '<span class="mida-volume-line__status" data-mida-line-status></span>' +
        '</div>';
    });

    lines.innerHTML = html;
    bindDropdownHandlers(lines);
  }

  function updateLineDetails(block) {
    var size = getSelectedSize();
    var color = getNativeSelectedColor();
    var nativeVariant = findVariant(color, size) || getCurrentVariantFromNative();
    var first = block.querySelector('[data-mida-volume-first]');

    if (first) {
      first.innerHTML =
        '<img src="' + getVariantImage(nativeVariant) + '" alt="" loading="lazy">' +
        '<span class="mida-volume-line__swatch" style="background:' + getSwatchColor(color) + '"></span>' +
        '<span><strong>1. Kissenbezug</strong><small>Farbe oben ausgewählt: ' + escapeHtml(color || 'Bitte auswählen') + '</small></span>';
    }

    toArray(block.querySelectorAll('[data-mida-extra-line]')).forEach(function (line) {
      var index = Number(line.dataset.index);
      var extraColor = state.extraColors[index];
      var variant = findVariant(extraColor, size);
      var img = line.querySelector('.mida-volume-line__img');
      var status = line.querySelector('[data-mida-line-status]');

      if (img) img.src = getVariantImage(variant);
      if (status) status.textContent = variant && variant.available !== false ? 'Auf Lager' : 'Nicht verfügbar';
    });
  }

  function buildSelection() {
    var size = getSelectedSize();
    var map = {};
    var compareCents = 0;
    var missing = [];

    getSelectionColors().forEach(function (color, index) {
      var variant = findVariant(color, size);

      if (!variant || variant.available === false) {
        missing.push('Kissenbezug ' + (index + 1));
        return;
      }

      compareCents += Number(variant.price) || 0;
      map[variant.id] = (map[variant.id] || 0) + 1;
    });

    return {
      items: Object.keys(map).map(function (id) {
        return { id: Number(id), quantity: map[id] };
      }),
      compareCents: compareCents,
      missing: missing
    };
  }

  function updatePrices(block) {
    var unitCents = getBaseUnitPrice();
    var tier = getTier(state.selectedQty);
    var selection = buildSelection();
    var compareCents = selection.compareCents || (unitCents * tier.qty);
    var finalCents = Math.round(compareCents * (1 - tier.discount));
    var savingsCents = Math.max(0, compareCents - finalCents);
    var colors = getSelectionColors();
    var size = getSelectedSize();

    toArray(block.querySelectorAll('[data-mida-volume-tier]')).forEach(function (card) {
      var t = getTier(card.dataset.qty);
      var tierCompare = unitCents * t.qty;
      var tierFinal = Math.round(tierCompare * (1 - t.discount));
      var isSelected = t.qty === state.selectedQty;
      var input = card.querySelector('.mida-volume-tier__input');
      var finalEl = card.querySelector('[data-mida-tier-final]');
      var compareEl = card.querySelector('[data-mida-tier-compare]');
      var unitEl = card.querySelector('[data-mida-tier-unit]');

      card.classList.toggle('is-selected', isSelected);
      if (input) input.checked = isSelected;
      if (finalEl) finalEl.textContent = formatMoney(tierFinal);
      if (compareEl) {
        compareEl.textContent = formatMoney(tierCompare);
        compareEl.hidden = t.discount === 0;
      }
      if (unitEl) unitEl.textContent = formatMoney(tierFinal / t.qty) + ' / Stück';

      toArray(card.querySelectorAll('.mida-volume-tier__media img')).forEach(function (img, index) {
        var c = colors[index] || colors[0] || getNativeSelectedColor();
        img.src = getVariantImage(findVariant(c, size));
      });
    });

    block.querySelector('[data-mida-volume-total]').textContent = formatMoney(finalCents);
    block.querySelector('[data-mida-volume-compare]').textContent = formatMoney(compareCents);
    block.querySelector('[data-mida-volume-compare]').hidden = tier.discount === 0;
    block.querySelector('[data-mida-volume-save]').textContent = tier.discount ? 'Du sparst ' + formatMoney(savingsCents) : 'Kein Rabatt ausgewählt';
  }

  function updateLabels(block) {
    var sizeLabel = block.querySelector('[data-mida-volume-size]');

    block.classList.toggle('is-single', state.selectedQty === 1);

    if (sizeLabel) sizeLabel.textContent = getSelectedSize() ? 'Größe: ' + getSelectedSize() : '';
  }

  function showError(message) {
    var block = document.querySelector('.mida-volume[data-mida-volume-product="' + PRODUCT_HANDLE + '"]');
    var error = block && block.querySelector('[data-mida-volume-error]');

    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function updateSubmitText() {
    var form = getMainForm();
    var button = form && form.querySelector('button[name="add"], [type="submit"][name="add"]');
    var label = button && button.querySelector('span');

    if (!label) return;

    if (!button.dataset.midaOriginalText) {
      button.dataset.midaOriginalText = label.textContent.replace(/\s+/g, ' ').trim();
    }

    label.textContent = state.selectedQty === 1 ? button.dataset.midaOriginalText : state.selectedQty + ' Kissenbezüge in den Warenkorb legen';
  }

  function updateDynamicUI() {
    var block = document.querySelector('.mida-volume[data-mida-volume-product="' + PRODUCT_HANDLE + '"]');

    if (!block) return;

    showError('');
    normalizeExtraColors();
    updateLabels(block);
    updateLineDetails(block);
    updatePrices(block);
    updateSubmitText();
  }

  function updateUI() {
    var block = document.querySelector('.mida-volume[data-mida-volume-product="' + PRODUCT_HANDLE + '"]');

    if (!block) return;

    showError('');
    normalizeExtraColors();
    renderExtraLines(block);
    updateDynamicUI();
  }

  function selectTier(qty) {
    state.selectedQty = getTier(qty).qty;
    normalizeExtraColors();
    closeAllDropdowns(null);
    updateUI();
  }

  function getCartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return /\.js($|\?)/.test(url) ? url : url + '.js';
  }

  function getCartDrawer() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setLoading(form, isLoading) {
    var button = form && form.querySelector('button[name="add"], [type="submit"][name="add"]');
    var spinner = button && button.querySelector('.loading__spinner');

    if (!button) return;

    button.classList.toggle('loading', isLoading);
    button.toggleAttribute('aria-disabled', isLoading);

    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function addSelectionToCart(form) {
    var cart = getCartDrawer();
    var selection = buildSelection();
    var body;

    if (state.adding) return;

    if (selection.missing.length || !selection.items.length) {
      showError('Bitte wähle verfügbare Farben aus.');
      return;
    }

    state.adding = true;
    showError('');
    setLoading(form, true);

    body = { items: selection.items };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          showError(response.description || 'Beim Hinzufügen ist ein Fehler aufgetreten.');
          return;
        }

        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        window.dispatchEvent(new Event('cart-update'));

        if (typeof cart.renderContents === 'function') cart.renderContents(response);
        if (typeof cart.open === 'function') cart.open();
      })
      .catch(function () {
        showError('Beim Hinzufügen ist ein Fehler aufgetreten. Bitte versuche es erneut.');
      })
      .finally(function () {
        state.adding = false;
        setLoading(form, false);
      });
  }

  function bindCartForm(form) {
    if (!form || form.dataset.midaVolumeBound === 'true') return;

    form.dataset.midaVolumeBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      updateDynamicUI();
      addSelectionToCart(form);
    }, true);
  }

  function bindVariantEvents() {
    var variantSelects = getVariantSelects();

    if (variantSelects && variantSelects.dataset.midaVolumeVariantBound !== VERSION) {
      variantSelects.dataset.midaVolumeVariantBound = VERSION;
      variantSelects.addEventListener('change', scheduleUpdate, true);
      variantSelects.addEventListener('input', scheduleUpdate, true);
    }
  }

  function insertBlock(block, form) {
    var buttons = form.querySelector('.product-form__buttons');
    var buyWrapper = form.querySelector('.buy-button__wrapper');

    if (buttons && buyWrapper) {
      buttons.insertBefore(block, buyWrapper);
      return;
    }

    form.insertBefore(block, form.firstChild);
  }

  function init() {
    var form;
    var block;

    if (!isTargetPage()) return;

    form = getMainForm();
    block = document.querySelector('.mida-volume[data-mida-volume-product="' + PRODUCT_HANDLE + '"]');

    if (!form || !getVariantSelects()) return;

    applySingleDiscountCohort();

    if (block && block.dataset.midaVersion !== VERSION) {
      block.remove();
      block = null;
    }

    loadVariants();
    bindVariantEvents();
    getCartForms().forEach(bindCartForm);
    form.classList.add('mida-volume-active');

    if (!block) {
      block = buildBlock();
      insertBlock(block, form);
    }

    updateUI();
  }

  function scheduleUpdate() {
    window.setTimeout(updateUI, 0);
    window.setTimeout(updateUI, 140);
    window.setTimeout(updateUI, 450);
  }

  function scheduleInit() {
    if (state.scheduled) return;

    state.scheduled = true;

    window.setTimeout(function () {
      state.scheduled = false;
      init();
    }, 80);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;

    if (!target || !target.closest) return;

    if (target.closest('variant-selects[data-product-handle="' + PRODUCT_HANDLE + '"]')) {
      scheduleUpdate();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('.mida-volume-dd')) {
      closeAllDropdowns(null);
    }
  });

  init();

  new MutationObserver(function () {
    var block = document.querySelector('.mida-volume[data-mida-volume-product="' + PRODUCT_HANDLE + '"]');
    if (!block) {
      scheduleInit();
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
